const RETURN_TO_KEY = 'portal.login.returnTo'

/** Only Portal destinations may survive an authentication round trip. */
export function safeReturnTo(value: string | null | undefined): string {
  if (
    !value ||
    !value.startsWith('/') ||
    value.startsWith('//') ||
    /[\\\u0000-\u0020]/.test(value)
  )
    return '/'
  try {
    const url = new URL(value, window.location.origin)
    const pathname = decodeURIComponent(url.pathname)
    if (
      url.origin !== window.location.origin ||
      pathname.startsWith('//') ||
      /[\\\u0000-\u0020]/.test(pathname) ||
      /^\/(login|signup|create-account|verify-email|email-verification-pending)(\/|$)/i.test(
        pathname,
      )
    )
      return '/'
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return '/'
  }
}

export function rememberReturnTo(value: string): string {
  const destination = safeReturnTo(value)
  try {
    sessionStorage.setItem(RETURN_TO_KEY, destination)
  } catch {
    /* Storage can be unavailable in private browsing. */
  }
  return destination
}

export function readReturnTo(): string {
  try {
    return safeReturnTo(sessionStorage.getItem(RETURN_TO_KEY))
  } catch {
    return '/'
  }
}

export function clearReturnTo(): void {
  try {
    sessionStorage.removeItem(RETURN_TO_KEY)
  } catch {
    /* Navigation still works without storage. */
  }
}
